import Alert from '../../../../v2/common/Alert';

export type VoucherInfoProps = {
  alertType?: 'info' | 'warning' | 'error' | 'success';
  title?: string;
  body?: React.ReactNode;
};

const VoucherInfo = ({ alertType = 'info', title, body }: VoucherInfoProps) => {
  return (
    <div className="mt-7 flex flex-col gap-x-3.5 rounded-lg lg:flex-row" role="alert">
      <Alert alertType={alertType} title={title || 'Cluey Voucher issued for holiday cancellation'} body={body} />
    </div>
  );
};

export default VoucherInfo;
